const ProjectFragment = `
fragment ProjectFragment on JiraProject {
  id
  projectId
  key
  uuid
  name
  avatar {
    medium
  }
  projectType
  projectStyle
  status
  created
}
`;

export const PROJECT_BY_KEY_QUERY = `
query jiraProjectByKey($projectKey: String!, $cloudId: ID!) {
  jira {
    jiraProjectByKey(key: $projectKey, cloudId: $cloudId) {
      ...ProjectFragment
    }
  }
}
${ProjectFragment}
`;

export const PROJECT_BY_ID_QUERY = `
query jiraProject($projectAri: ID!) {
  jira {
    jiraProject(id: $projectAri) {
      ...ProjectFragment
    }
  }
}
${ProjectFragment}
`;

/**
 * @deprecated delete when cleaning up fetch-project-avatar-url-in-project-context-resource_7e1me
 */
const ProjectFragmentOld = `
fragment ProjectFragment on JiraProject {
  id
  projectId
  key
  uuid
  name
  projectType
  projectStyle
  status
  created
}
`;

/**
 * @deprecated delete when cleaning up fetch-project-avatar-url-in-project-context-resource_7e1me
 */
export const PROJECT_BY_KEY_QUERY_OLD = `
query jiraProjectByKey($projectKey: String!, $cloudId: ID!) {
  jira {
    jiraProjectByKey(key: $projectKey, cloudId: $cloudId) {
      ...ProjectFragment
    }
  }
}
${ProjectFragmentOld}
`;

/**
 * @deprecated delete when cleaning up fetch-project-avatar-url-in-project-context-resource_7e1me
 */
export const PROJECT_BY_ID_QUERY_OLD = `
query jiraProject($projectAri: ID!) {
  jira {
    jiraProject(id: $projectAri) {
      ...ProjectFragment
    }
  }
}
${ProjectFragmentOld}
`;
